import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminTransactions() {
  const [txs, setTxs] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    const q = filter === "all" ? "" : `?status=${filter}`;
    try {
      const { data } = await api.get(`/admin/transactions${q}`);
      setTxs(data);
    } catch (err) { toast.error(formatApiError(err)); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const approve = async (id) => {
    try {
      await api.post("/admin/transactions/approve", { transaction_id: id });
      toast.success("Onaylandı");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const reject = async (id) => {
    try {
      await api.post("/admin/transactions/reject", { transaction_id: id });
      toast.success("Reddedildi");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const Chip = ({ v, label }) => (
    <button
      onClick={() => setFilter(v)}
      data-testid={`filter-${v}`}
      className={`text-xs uppercase tracking-[0.15em] px-3 py-1.5 border transition-colors ${filter === v ? "border-[hsl(221,83%,53%)] text-white bg-[hsl(221,83%,53%)]/10" : "border-white/15 text-white/60 hover:text-white"}`}
    >
      {label}
    </button>
  );

  const Status = ({ s }) => {
    const map = { 0: { l: "Bekliyor", c: "text-[hsl(38,92%,60%)] border-[hsl(38,92%,60%)]/40" }, 1: { l: "Onay", c: "text-[hsl(142,71%,55%)] border-[hsl(142,71%,55%)]/40" }, 2: { l: "Red", c: "text-red-400 border-red-500/40" } };
    const m = map[s] || map[0];
    return <span className={`border px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] font-bold ${m.c}`}>{m.l}</span>;
  };

  return (
    <AdminLayout>
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-2">Finans</div>
        <h1 className="font-display text-3xl font-black">Bakiye Bildirimleri</h1>
      </div>

      <div className="flex gap-2 mb-6">
        <Chip v="all" label="Hepsi" />
        <Chip v="0" label="Bekleyen" />
        <Chip v="1" label="Onaylanan" />
        <Chip v="2" label="Reddedilen" />
      </div>

      <div className="border border-white/10 bg-[hsl(0,0%,7%)] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-[0.2em] text-white/40 border-b border-white/10">
            <tr>
              <th className="text-left py-3 px-4 font-bold">Kullanıcı</th>
              <th className="text-left px-4 font-bold">Yöntem</th>
              <th className="text-right px-4 font-bold">Tutar</th>
              <th className="text-left px-4 font-bold">Referans</th>
              <th className="text-left px-4 font-bold">Tarih</th>
              <th className="text-left px-4 font-bold">Durum</th>
              <th className="text-right px-4 font-bold">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {txs.length === 0 && (
              <tr><td colSpan={7} className="py-8 text-center text-white/40">Kayıt yok.</td></tr>
            )}
            {txs.map((t) => (
              <tr key={t.id} className="border-b border-white/5">
                <td className="py-3 px-4 font-mono">{t.username}</td>
                <td className="px-4 uppercase text-xs tracking-wider text-white/70">{t.method}</td>
                <td className="px-4 text-right font-mono font-bold">₺{Number(t.amount).toFixed(2)}</td>
                <td className="px-4 text-white/60 text-xs max-w-[200px] truncate" title={t.reference}>{t.reference || "—"}</td>
                <td className="px-4 text-white/50 text-xs">{new Date(t.created_at).toLocaleString("tr-TR")}</td>
                <td className="px-4"><Status s={t.status} /></td>
                <td className="px-4 text-right">
                  {t.status === 0 && (
                    <div className="flex justify-end gap-2">
                      <button onClick={() => approve(t.id)} data-testid={`tx-approve-${t.id}`} className="bg-[hsl(142,71%,45%)] hover:bg-[hsl(142,71%,50%)] text-white text-xs px-3 py-1 uppercase tracking-wider font-bold transition-colors">Onayla</button>
                      <button onClick={() => reject(t.id)} data-testid={`tx-reject-${t.id}`} className="border border-white/20 hover:border-red-500 hover:text-red-400 text-xs px-3 py-1 uppercase tracking-wider transition-colors">Reddet</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
